import(/* webpackChunkName: "lotteryTicketActivation" */ '../../Styles/lotteryTicketActivation.scss');

await import(/* webpackChunkName: "jquery-match-height" */ 'jquery-match-height');
await import(/* webpackChunkName: "forEach" */ 'Feature/Common/code/Scripts/Common/forEach');
await import(/* webpackChunkName: "sync" */ 'Feature/Common/code/Scripts/Common/sync');
await import(/* webpackChunkName: "parents" */ 'Feature/Common/code/Scripts/Common/parents');
await import(/* webpackChunkName: "ajax" */ 'Feature/Common/code/Scripts/Common/ajax');
await import(/* webpackChunkName: "postalcodeCountryValidator" */ 'Feature/Forms/code/Scripts/postalcodeCountryValidator');
await import(/* webpackChunkName: "lotteryTicketFormat" */ 'Foundation/LotteryTicket/code/Scripts/LotteryTicket/lotteryTicketFormat');
await import(/* webpackChunkName: "lotteryTicketStartNumbers" */ 'Foundation/LotteryTicket/code/Scripts/LotteryTicket/lotteryTicketStartNumbers');
await import(/* webpackChunkName: "explanationSlider" */ 'Feature/LotteryContentElements/code/Scripts/LotteryTicket/explanationSlider');
await import(/* webpackChunkName: "tools" */ 'Common/Scripts/Common/tools');
await import(/* webpackChunkName: "ticket" */ 'Common/Scripts/Ticket/ticket');
await import(/* webpackChunkName: "input-mask" */ 'Foundation/Forms/code/Scripts/input-mask');
await import(/* webpackChunkName: "iban" */ 'Foundation/Forms/code/Scripts/iban');
await import(/* webpackChunkName: "base64" */ 'Foundation/Common/code/Scripts/Common/base64');
await import(/* webpackChunkName: "birthdayFormat" */ 'Foundation/Common/code/Scripts/Common/birthdayFormat');
await import(/* webpackChunkName: "groupFormat" */ 'Common/Scripts/Common/groupFormat');
await import(/* webpackChunkName: "matchesProperty" */ 'Foundation/Forms/code/Scripts/matchesProperty');
await import(/* webpackChunkName: "password" */ 'Foundation/Forms/code/Scripts/password');
await import(/* webpackChunkName: "passwordOnly" */ 'Foundation/Forms/code/Scripts/passwordOnly');
await import(/* webpackChunkName: "dateformat" */ 'Foundation/Forms/code/Scripts/dateformat');
await import(/* webpackChunkName: "requiredAdvanced" */ 'Foundation/Forms/code/Scripts/requiredAdvanced');
await import(/* webpackChunkName: "requiredWhen" */ 'Foundation/Forms/code/Scripts/requiredWhen');
await import(/* webpackChunkName: "requiredLegalAge" */ 'Foundation/Forms/code/Scripts/requiredLegalAge');
const passwordCriteria = await import(/* webpackChunkName: "passwordCriteria" */ 'Foundation/Forms/code/Scripts/passwordCriteria');
await import(/* webpackChunkName: "disallowCharacter" */ 'Foundation/Forms/code/Scripts/disallowCharacter');
await import(/* webpackChunkName: "forms" */ 'Feature/Forms/code/Scripts/forms');
await import(/* webpackChunkName: "postalcodeCountryFormValidationInitializer" */ 'Feature/Forms/code/Scripts/postalcodeCountryFormValidationInitializer');
await import(/* webpackChunkName: "extendHTMLElement" */ 'Common/Scripts/Common/extendHTMLElement');

window.am = window.am || {};
window.am.lotteryTicketActivation = new function () {
    var that = this;
    that.containerClassName = '.lotteryticket-activation';

    // Initialize all components and functionalities
    that.init = function () {
        if (initializeContainers()) {
            initIban();
            initShowHidePassword();
            initAccordionRichtext();
            initLogin();
            initializeUserInterface();
            manageSubmitButtonState();
        }
    }

    that.radioGroups = ['SalutationOption', 'ProfitPayout', 'CreateAccount'];
    that.textInputs = ['Email', 'PostalCode', 'City', 'StreetName', 'Birthday', 'LastName', 'FirstName'];
    that.extInputs = ['Password', 'PasswordConfirmation', 'Iban'];

    const UserType = Object.freeze({
        GUEST: 'guest',
        NEW_USER: 'newUser',
        REG_USER: 'regUser'
    });

    // Iban
    function initIban() {
        initShowHideIban();
        initializeIbanInputHandlers();
        initializeIbanCreateNewButton();
    }

    function initShowHideIban() {
        var lotteryActivationForms = allByQuery('.lotteryticket-activation');

        if (lotteryActivationForms == null) {
            return;
        }

        for (var i = 0; i < lotteryActivationForms.length; i++) {
            var lotteryActivationForm = lotteryActivationForms[i];

            window.am.forms.initShowHideIbanByParent(lotteryActivationForm, 'ProfitPayout', changedCallback);
        }
    }

    function initializeIbanInputHandlers() {
        const ibanFields = allByQuery('input#Iban');
        if (!ibanFields) return;

        ibanFields.forEach(field => {
            field.addEventListener('input', function () {
                const ibanFieldElement = this.closest('.form-field.iban-various-validation.validation-service-error');
                if (ibanFieldElement) {
                    submitValidationFailedFunc(ibanFieldElement, this);
                }
            });
        });
    }

    function initializeIbanCreateNewButton() {
        const createNewBtn = byId('IbanCreateNew');
        if (createNewBtn) {
            createNewBtn.addEventListener('click', function (event) {
                event.preventDefault();
                byId('IbanSelectContainer').addClassHidden();
                byId('IbanText').addClassHidden();
                byId('IbanInputContainer').removeClassHidden();

                byId('IbanText').value = "";
                validateForm();
                this.hideElement();
            });
        }
    }

    // Login
    function initLogin() {
        setupLoginFormValidation();
        setupLoginFormSubmit();
    }

    function setupLoginFormValidation() {
        const $loginForm = $('#LoginForm');

        $loginForm.validate({
            rules: {
                'username-field': { required: true, email: true },
                'password-field': { required: true }
            },
            validClass: 'success',
            errorClass: 'error',
            errorPlacement: (error, element) => {
                const html = `
                    <div class='field-error'>
                        <div class='message'>
                            <span class='info-icon icon icons-information-bold'></span>
                            <p><span class='field-validation-error'>${error.html()}</span></p>
                        </div>
                    </div>`;
                element.closest('.form-field').find('.field-error').remove();
                $(html).insertAfter(element);
            }
        });

        $loginForm.find('input').on('blur', (e) => $(e.target).valid());
    }

    function setupLoginFormSubmit() {
        const $loginForm = $('#LoginForm');
        const $loginBtn = $('#LoginFormLoginButton');
        const $usernameField = $('#LoginFormUsername');
        const $passwordField = $('#LoginFormPassword');

        $loginForm.on('submit', async (e) => {
            e.preventDefault();
            if ($loginBtn.prop('disabled')) return;

            const username = $usernameField.val()?.trim();
            const password = $passwordField.val()?.trim();

            if (validateLoginForm(username, password)) {
                await handleLoginSubmission($loginBtn, $loginForm, username, password);
            } else {
                reset($loginBtn, $loginForm);
            }
        });
    }

    function validateLoginForm(username, password) {
        return !isEmptyOrNull(username) &&
            !isEmptyOrNull(password) &&
            validateEmail(username.trim());
    }


    async function handleLoginSubmission($loginBtn, $loginForm, username, password) {
        $loginBtn.prop('disabled', true);
        hideError($loginForm);

        try {
            const result = await loginUser(username, password);
            if (result.Success) window.location.reload();
            else reset($loginBtn, $loginForm);
        } catch (error) {
            reset($loginBtn, $loginForm);
        } finally {
            $loginBtn.prop('disabled', false);
        }
    }

    // Main WorkFlow
    function initializeUserInterface() {
        const createNewIbanButton = byId('IbanCreateNew');
        createNewIbanButton?.click();

        const userDataIsEmpty = isEmpty(UserData, ['Country'])
        if (userDataIsEmpty) {
            handleUserAuthentication();
        }
        else {
            if (hasFormErrors()) {
                setupInitialVisibility();
            }
            else {
                setupInitialVisibility(true);
            }
        }
    }

    function hasFormErrors() {
        const form = byId('UserDataForm');
        const notifications = form.querySelector('.global-notification-container.notification-container');
        const hasMsg = notifications ? notifications.classList.contains('active') : false;
        return !$(form).validate().checkForm() || hasMsg;
    }


    async function handleUserAuthentication() {
        try {
            byQuery(`${that.containerClassName}__loading`)?.showElement();

            const isLoggedIn = await isUserLogin();
            if (isLoggedIn) {
                // show summary form
                await handleUserData();
                // await Promise.all([handleUserData(), handleIbanData()]);
                setupInitialVisibility(true, isLoggedIn);
            } else {
                // show edited form
                setupInitialVisibility();
            }
        } catch (error) {
            setupInitialVisibility();
        }
    }


    async function handleUserData() {
        try {
            const user = await getUser();
            populateUserData(user);
        } catch (error) {
            byQuery(`${that.containerClassName}__loading`)?.hideElement();
            byQuery(`${that.containerClassName}__customer-info-form`)?.showElement();
        } finally {
            byQuery(`${that.containerClassName}__customer-iban`)?.showElement();
        }
    }

    function setupInitialVisibility(showSummaryForm = false, isLoggedIn = false) {
        const userDataIsEmpty = isEmpty(UserData, ['Country'])
        const containers = [
            byQuery(`${that.containerClassName}__login`),
            byQuery(`${that.containerClassName}__customer-info`),
            byQuery(`${that.containerClassName}__customer-info-form`),
            byQuery(`${that.containerClassName}__customer-iban`),
            byQuery(`${that.containerClassName}__loading`)
        ];

        containers.forEach(container => container?.showElement());

        if (showSummaryForm) {
            if (!userDataIsEmpty) {
                fillUserSummary(UserData);
            }

            byQuery(`${that.containerClassName}__customer-info-form`)?.hideElement();
            byQuery(`${that.containerClassName}__login`)?.hideElement();
            passwordSection()?.hideElement();

            if (getUserType() != UserType.GUEST) {
                byId('SummaryEditEmail')?.hideElement();
                toggleFieldState(true);
            }
        } else {
            byQuery(`${that.containerClassName}__customer-info`)?.hideElement();
            if (!userDataIsEmpty) {
                byQuery(`${that.containerClassName}__login`)?.hideElement();
                passwordSection()?.hideElement();
            } else {
                if (passwordSection() != null) {
                    passwordCriteria.default('lotteryticket-activation', 'lotteryticket-activation');
                }
            }
        }

        byId('IsGuestUser').value = 'false';
        if (isLoggedIn) {
            handleIbanData();
            byId('IbanSelected').addEventListener('change', (event) => {
                var select = event.target;
                var selectedValue = select.value;
                if (select.value != "") {
                    byId('IbanText').value = select.options[select.selectedIndex].text;
                }
                validateForm()
            });
        } else {
            const IbanText = byId('IbanText').getAttribute('value');
            if (!isEmptyOrNull(IbanText)) {
                byId('IbanText').removeClassHidden();
                byId('IbanText').value = IbanText;
                byId('IbanCreateNew').showElement();
                byId('IbanInputContainer').addClassHidden();
            } else {
                byId('IbanCreateNew')?.click();
            }
        }

        byQuery(`${that.containerClassName}__loading`)?.hideElement();
    }

    async function handleIbanData() {
        try {
            const ibanResult = await getIbans();
            handleIbanResponse(ibanResult);
        } catch (error) {
            handleIbanError();
        }
    }

    function handleIbanResponse(result) {
        const selectElement = byId('IbanSelected');
        const IbanInput = byId('Iban');

        if (result.status.code === 'OK' && Array.isArray(result.data.ibanList) && result.data.ibanList.length != 0) {
            result.data.ibanList.forEach(item => {
                const option = document.createElement('option');
                option.value = item.paymentId;
                option.textContent = item.iban;
                selectElement.appendChild(option);
            });

            //if (result.data.ibanList.length == 1) {
            //    byId('IbanSelected').value = result.data.ibanList[0].paymentId;
            //    byId('IbanText').value = result.data.ibanList[0].iban;

            //    byId('IbanSelectContainer').addClassHidden();
            //    byId('IbanText').removeClassHidden();
            //} else {
            //    byId('IbanSelectContainer').removeClassHidden();
            //    byId('IbanText').addClassHidden();
            //}

            byId('IbanSelectContainer').removeClassHidden();
            byId('IbanText').addClassHidden();
            byId('IbanCreateNew').showElement();
            byId('IbanInputContainer').addClassHidden();

        } else {
            handleIbanError();
        }
    }

    function handleIbanError() {
        console.error('IBAN data retrieval failed');
        byId('IbanCreateNew')?.click();
    }


    // Misc 
    // Helper: Check if a radio group has a selected option
    function isRadioGroupFilled(name) {
        return byQuery(`input[name="${name}"]:checked`) !== null;
    }

    // Helper: Check if a text input has a non-empty value
    function isTextInputFilled(id) {
        const el = document.getElementById(id);
        return el && el.value.trim() !== '';
    }

    // Main validation function
    function validateForm() {
        const form = byId('UserDataForm');
        if (!form) return;

        const submitButton = form.querySelector('button[type="submit"]');
        if (!submitButton) return;


        let allFilled = true;

        // Check radio groups
        for (const name of that.radioGroups) {
            const radioEl = byQuery(`input[name="${name}"]`);
            if (!radioEl || radioEl.offsetParent === null) continue;

            if (!isRadioGroupFilled(name)) {
                allFilled = false;
                break;
            }
        }

        // Check text inputs
        for (const id of that.textInputs) {
            const textEl = byId(id);
            if (!textEl) continue;

            if (!isTextInputFilled(id)) {
                allFilled = false;
                break;
            }
        }

        // Check ext inputs
        for (const id of that.extInputs) {
            const textEl = byId(id);
            if (!textEl || textEl.offsetParent === null) continue;

            if (!isTextInputFilled(id)) {
                allFilled = false;
                break;
            }
        }

        submitButton.addElementClass('is-disabled');
        if (allFilled && $(form).validate().checkForm()) {
            submitButton.removeElementClass('is-disabled');
        }
    }

    function manageSubmitButtonState() {
        const $form = $('#UserDataForm');
        const validator = $form.data("validator"); // Get the validator instance

        if (validator) {
            // Change settings to validate on focusout
            validator.settings.onfocusout = function (element) {
                $(element).valid();
            };
        }

        // Attach event listeners to radio groups
        that.radioGroups.forEach(name => {
            const radios = allByQuery(`input[name="${name}"]`);
            radios.forEach(radio => {
                radio.addEventListener('change', validateForm);
            });
        });

        // Attach event listeners to text inputs
        that.textInputs.forEach(id => {
            const el = byId(id);
            if (el) {
                el.addEventListener('input', validateForm);
                el.addEventListener('change', validateForm);
            }
        });

        // Attach event listeners to exta inputs
        that.extInputs.forEach(id => {
            const el = byId(id);
            if (el) {
                el.addEventListener('input', validateForm);
                el.addEventListener('change', validateForm);
            }
        });

        // Initial validation
        validateForm();
    }

    function initAccordionRichtext() {
        var textsWithAdditionalText = allByQuery('.richtext.with-additional-text a[data-additional-text]');

        for (var j = 0; j < textsWithAdditionalText.length; j++) {
            var textWithAdditionalText = textsWithAdditionalText[j];

            textWithAdditionalText.addEventListener('click', function (e) {
                e.preventDefault();
                toggleAdditionalText(this);
            });
        }
    }

    function initShowHidePassword() {
        var lotteryActivationForms = allByQuery('.lotteryticket-activation');

        if (lotteryActivationForms == null) {
            return;
        }

        for (var i = 0; i < lotteryActivationForms.length; i++) {
            var lotteryActivationForm = lotteryActivationForms[i];

            window.am.forms.initShowHideElementsByParent(lotteryActivationForm, 'CreateAccount', 'false', 'true', (element, targetElement) => { }, this);
        }
    }

    function initializeContainers() {
        const lotteryActivationForm = byQuery(that.containerClassName);
        const loginContainer = lotteryActivationForm?.querySelector(`${that.containerClassName}__login`);

        if (!lotteryActivationForm || !loginContainer) return false;

        setupHeaderToggle(loginContainer);

        return true;
    }

    function setupHeaderToggle(loginContainer) {
        const headerContainer = loginContainer.querySelector(`${that.containerClassName}__login__header .icon`);
        headerContainer?.addEventListener('click', () => {
            loginContainer.classList.toggle(`${that.containerClassName}__login--active`.replace('.', ''));
        });
    }

    function getUserType() {
        if (!IsAccountCreated && (UserData.CustomerId == '' || UserData.CustomerId == '0')) {
            return UserType.GUEST;
        }
        else if (IsAccountCreated) {
            return UserType.NEW_USER;
        }
        else if (UserData.CustomerId != '' && UserData.CustomerId != '0') {
            return UserType.REG_USER
        }
        else {
            return 'Unknown User Type';
        }
    }

    function populateUserData(user) {
        UserData.FirstName = user.FirstName;
        UserData.LastName = user.LastName;
        UserData.BirthDate = user.BirthDate;
        UserData.Email = user.Email;
        UserData.Street = user.Street;
        UserData.StreetNumber = user.StreetNumber;
        UserData.PostalCode = user.PostalCode;
        UserData.City = user.City;
        UserData.CountryCode = user.CountryCode;
        UserData.CustomerId = user.CustomerID;

        byId('CustomerId').value = user.CustomerID;
        showCustomerInfo(user);

        const subscription = byId('CustomerSubscriptionSection');
        const subscriptionInsideContainer = byQuery(`${that.containerClassName}__customer-info-form__subscription-inside-container`);

        subscription.querySelector('.subline').classList.remove('mt-4');
        subscriptionInsideContainer.appendChild(subscription);
        subscriptionInsideContainer.removeClassHidden();
    }

    function passwordSection() {
        const customerInfoFormContainer = byQuery(`${that.containerClassName}__customer-info-form`);
        return customerInfoFormContainer.querySelector('[data-toggle-visibility-selector="#PasswordContainer"]');
    }

    // Callback Functions
    function changedCallback(element, targetElement) {
        if (element.value == 'false') {
            // get correct txt field
            var ibanField = targetElement.querySelector('input[type="text"]:not(:disabled):not(:read-only)');

            if (ibanField) {
                ibanField.value = '';
                /* values changes via js doesnt trigger input change event */
                triggerChangeEvent(ibanField, 'input');

                var $iban = $(ibanField);

                $iban.valid();
            }
        }
    }

    // DOM Manipulation Functions
    function toggleFieldState(fieldState) {
        allByQuery('#SalutationF, #SalutationH, #SalutationA, #TitleOption, #FirstName, #LastName, #Birthday, #Email').forEach((item) => {
            item.readOnly = fieldState;
        });
    }

    function showCustomerInfo(user) {
        fillEditUserForm(user);
        fillUserSummary(user);
    }

    function fillEditUserForm(user) {
        // Salutation
        if (user.Salutation === 'F') {
            byId('SalutationF').checked = true;
        } else if (user.salutation === 'H') {
            byId('SalutationH').checked = true;
        } else {
            byId('SalutationA').checked = true;
        }
        byId('TitleOption').value = user.Title;
        // First Name
        byId('FirstName').value = user.FirstName;
        // Last Name
        byId('LastName').value = user.LastName;
        // Birthday
        byId('Birthday').value = user.BirthDate;
        // Email
        byId('Email').value = user.Email;
        // Address
        byId('StreetName').value = user.Street;
        byId('StreetNumber').value = user.StreetNumber;
        byId('PostalCode').value = user.PostalCode;
        byId('City').value = user.City;
        // Country
        byId('CountryCode').value = user.CountryCode;
        // Phone Number
        byId('Phonenumber').value = user.Phone;
    }

    function fillUserSummary(user) {
        byId('SummaryFullName').textContent = `${user.FirstName} ${user.LastName}`;
        byId('SummaryDateOfBirth').textContent = user.BirthDate;
        byId('SummaryEmail').textContent = user.Email;
        byId('SummaryStreet').textContent = user.Street + ' ' + user.StreetNumber;
        byId('SummaryZipCode').textContent = user.PostalCode;
        byId('SummaryCity').textContent = user.City;

        const country = Countries.find(x => x.code == user.CountryCode);
        byId('SummaryCountry').textContent = (country == null ? user.CountryCode : country.name);

        allByQuery(`${that.containerClassName}__customer-info__container__right a`).forEach(x => x.addEventListener('click', toggleView));
    }

    function toggleView(event) {
        const customerInfoContainer = byQuery(`${that.containerClassName}__customer-info`);
        const customerInfoFormContainer = byQuery(`${that.containerClassName}__customer-info-form`);
        if (customerInfoContainer.isElementVisible()) {
            // Switch to edit view
            customerInfoContainer.hideElement();
            customerInfoFormContainer.showElement();

            if (event.currentTarget.id.includes('Personal')) {
                resetForm();
                validateForm();
            }
        } else {
            // Switch to read-only form
            customerInfoContainer.showElement();
            customerInfoFormContainer.hideElement();
        }
    }

    function resetForm() {
        toggleFieldState(false);

        const form = byId('UserDataForm');
        form.reset(); // Attempt to reset the form
        for (const element of form.elements) {
            const fieldType = element.type.toLowerCase();

            switch (fieldType) {
                case "text":
                case "email":
                case "password":
                case "textarea":
                case "hidden":
                    element.value = "";
                    break;
                case "radio":
                case "checkbox":
                    if (element.checked) {
                        element.checked = false;
                    }
                    break;
                case "select-one":
                case "select-multi":
                    // deleting this option when the form is resseted as requested by QA
                    // this will be re-added when the page loads again
                    if (element.id === "TitleOption") {
                        if (element.firstElementChild.textContent === "Bitte wählen") {
                            element.remove(element.options[0])
                        }
                    }
                    element.selectedIndex = -1;
                    break;
                default:
                    break;
            }
        }

        byId('IbanSelected').value = '';
        byId('CustomerId').value = 0;
        byId('IsGuestUser').value = 'true';

        byId('IbanSelectContainer').addClassHidden();
        byId('IbanText').addClassHidden();
        byId('IbanCreateNew').addClassHidden();
        byId('IbanInputContainer').removeClassHidden();
        byId('IbanContainer').addClassHidden();
    }

    // Validation Functions
    function validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function submitValidationFailedFunc(ibanFieldItem, element) {

        let form = ibanFieldItem.parent('.am-form');

        if (form == null) {
            return false;
        }

        var withValidationServiceErrorFields = form.querySelectorAll('.validation-service-error');

        if (withValidationServiceErrorFields && withValidationServiceErrorFields.length == 1) {
            //Do error container magic
            let notificationContainer = form.querySelector('.global-notification-container.notification-container');

            if (notificationContainer == null) {
                return false;
            }

            if (notificationContainer.classList.contains('active')) {
                let errorMessageLinkElement = notificationContainer.querySelector('a[href="#Iban"]');
                if (errorMessageLinkElement) {
                    let errorMessageListElement = errorMessageLinkElement.parent('li');
                    if (errorMessageListElement) {
                        let ulElement = errorMessageListElement.parent('ul')
                        if (ulElement) {
                            ulElement.removeChild(errorMessageListElement);
                            let otherErrorMessageListElements = ulElement.querySelectorAll('li');
                            if (!otherErrorMessageListElements || (otherErrorMessageListElements && otherErrorMessageListElements.length == 0)) {
                                notificationContainer.classList.remove('active');
                                notificationContainer.classList.add('no-errors');
                            }
                        }
                    }
                }
            }
        }

        ibanFieldItem.classList.remove(that.inputErrorClass);
        ibanFieldItem.classList.add('no-errors');
        ibanFieldItem.classList.remove('validation-service-error');
        let fieldNotificationContainer = ibanFieldItem.querySelector('.error.notification-container');
        fieldNotificationContainer.querySelector('div.message').querySelector('p').innerHTML = element.getAttribute('data-alt-validation-message');
    }

    function isEmptyOrNull(str) {
        return (!str || str.trim().length === 0);
    }

    function isEmpty(obj, keysToExclude = []) {
        for (let key in obj) {
            if (!keysToExclude.includes(key) && obj.hasOwnProperty(key) && obj[key] !== '') {
                return false;
            }
        }

        return true;
    }

    // Error handling functions
    function reset($loginBtn, $loginForm) {
        $loginBtn.prop('disabled', false);
        showError($loginForm);
    }

    function hideError(container) {
        container.find('.submit.field-error').hide();
    }

    function showError(container) {
        container.find('.submit.field-error').show();
    }

    // API Interaction Functions
    async function loginUser(username, password) {
        const formData = {
            LoginName: username,
            Password: password
        };

        try {
            const response = await fetch(window.origin + '/api/sitecore/LoginApi/Login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            return await response.json();
        } catch (error) {
            return false;
        }
    }

    async function isUserLogin() {
        try {
            let response = await fetch(window.origin + '/api/sitecore/LoginApi/IsUserLogin');

            return await response.json();
        } catch (error) {
            return false;
        }
    }

    async function getUser() {
        try {
            let response = await fetch(window.origin + '/api/sitecore/LoginApi/GetUser');

            return await response.json();
        } catch (error) {
            return false;
        }
    }

    async function getIbans() {
        try {
            let response = await fetch(window.origin + '/api/lotterie/checkout/customer/iban');

            return await response.json();
        } catch (error) {
            return false;
        }
    }

    async function updateUser(customer) {
        const formData = {
            customer: customer
        };

        try {
            const response = await fetch(window.origin + '/api/sitecore/LoginApi/UpdateUser', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            return await response.json();
        } catch (error) {
            return false;
        }
    }

    // Utility Functions
    function triggerChangeEvent(element, eventName) {
        var event;

        /* With IE support */
        if (typeof (Event) === 'function') {
            event = new Event(eventName);
        }
        else {
            event = document.createEvent('Event');
            event.initEvent(eventName, true, true);
        }

        element.dispatchEvent(event);
    }

    function byId(id) {
        return document.getElementById(id);
    }

    function byQuery(query) {
        return document.querySelector(query);
    }

    function allByQuery(query) {
        return document.querySelectorAll(query);
    }

    function toggleAdditionalText(element) {
        var richtextParent = element.parent('.with-additional-text');

        if (!richtextParent) {
            return;
        }

        var additionalText = richtextParent.querySelector('.additional-text');

        if (additionalText != null && additionalText != undefined) {
            if (additionalText.classList.contains('show')) {
                additionalText.classList.remove('show');
                $(additionalText).stop().slideUp();
            }
            else {
                additionalText.classList.add('show');
                $(additionalText).stop().slideDown();
            }
        }
    }
}

window.am.lotteryTicketActivation.init();